import AdminLabsPage from './admin-labs-page';

export default function AdminLabsGridPage() {
  return <AdminLabsPage />;
}
